import type { CommentElementProps } from './comment-element.component';
import CommentElement from './comment-element.component';

export interface CommentsListProps {
  comments?: Array<CommentElementProps>;
  readOnly?: boolean;
  formatDate?: (date: Date) => string;
}

export default function CommentsList({ comments, readOnly, formatDate }: CommentsListProps): React.JSX.Element {
  return (
    <>
      {comments?.map((comment, index) => {
        return (
          <div key={comment.id || comment.date || `comment-${index}`} className="overflow-x-auto">
            <CommentElement
              user={comment.user}
              date={comment.date}
              message={comment.message}
              readOnly={readOnly}
              formatDate={formatDate}
            />
          </div>
        );
      })}
    </>
  );
}
